import { Link } from "react-router-dom";
import { ArrowRight, Bot } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { TopographicBackdrop } from "./TopographicBackdrop";

const SOCIAL_PROOF = ["Acme Ops", "NovaShip", "Harborline", "Cortex Labs", "Riverstone"];

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <TopographicBackdrop />
      {/* Radial violet gradient */}
      <div
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(124,58,237,0.25),transparent_55%)]"
        aria-hidden
      />
      <div
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-violet/40 to-transparent"
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-20 md:pt-24 md:pb-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1">
              <Bot className="h-3.5 w-3.5 text-brand-violet" />
              <span className="text-xs font-medium text-brand-ink/80">
                Hire in minutes. Audit every action.
              </span>
            </div>

            <h1 className="mt-6 font-display text-6xl md:text-7xl lg:text-8xl tracking-wide leading-[0.95] text-brand-ink">
              Hire your next teammate.
              <span className="block text-brand-violet">Skip the offer letter.</span>
            </h1>

            <p className="mt-6 text-lg md:text-xl text-brand-ink/70 leading-relaxed max-w-xl">
              VirtualDesk.ai is a one-stop hiring platform for AI-powered virtual employees.
              Sign up, pick a subdomain, and staff a digital team that ships real work in minutes.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button asChild size="lg" variant="primary">
                {/* TODO: track event — hero_cta_primary_click */}
                <Link to="/register">
                  Get started
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white/20 text-brand-ink hover:bg-white/5">
                {/* TODO: track event — hero_cta_secondary_click */}
                <Link to="/contact">Book a demo</Link>
              </Button>
            </div>

            <div className="mt-12">
              <p className="text-xs uppercase tracking-wider text-brand-ink/40">
                Used by teams at
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {SOCIAL_PROOF.map((name) => (
                  <span
                    key={name}
                    className="inline-flex items-center rounded-md border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-brand-ink/70"
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="relative">
            <div
              className="relative w-full aspect-[2/1] max-w-xl mx-auto rounded-2xl overflow-hidden border border-white/10 bg-brand-midnight shadow-2xl shadow-brand-violet/20"
              role="img"
              aria-label="Office scene with virtual employees coordinating with AI agents"
            >
              <video
                className="w-full h-full object-cover"
                src="/hero-office.webm"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                aria-hidden
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
